import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useVendorRegistration } from './useVendorRegistration';
import { registrationSchema, VendorRegistrationPayload } from '@/schemas/registration.schema';
import { zodResolver } from '@hookform/resolvers/zod';

export const useRegistrationData = () => {
    const [step, setStep] = useState(1);

    const [showPassword, setShowPassword] = useState(false);

    const { isPending: loading, mutateAsync: registerVendor } = useVendorRegistration();

    const defaultValues: VendorRegistrationPayload = {
        businessName: '',
        ownerName: '',
        email: '',
        password: '',
        confirmPassword: '',
        phone: '',
        businessPhone: '',
        businessAddress: '',
        businessType: '',
        cuisineTypes: [],
        description: '',
        hasWhatsAppBusiness: false,
        whatsappBusinessId: '',
        whatsappAccessToken: '',
        whatsappPhoneNumber: '',
    };
    const {
        register,
        handleSubmit,
        formState: { errors },
        trigger,
        getValues,
        setValue,
        watch,
    } = useForm<VendorRegistrationPayload>({
        resolver: zodResolver(registrationSchema) as any,
        defaultValues,
        mode: 'onChange',
    });

    const onSubmit = async (data: VendorRegistrationPayload) => {
        const registrationData = {
            ...data,
            whatsappPhoneNumber: data.whatsappPhoneNumber || data.businessPhone
        };

        await registerVendor(registrationData);
    };

    const handleNextStep = async () => {
        const isValid = await trigger([
            'businessName',
            'ownerName',
            'email',
            'password',
            'confirmPassword',
        ]);

        if (isValid && getValues('password') === getValues('confirmPassword')) {
            setStep(2);
        }
    };

    const handlePreviousStep = () => {
        setStep(1);
    };

    const toggleCuisine = (cuisine: string) => {
        const cuisineTypes = getValues('cuisineTypes') || [];

        const updated = cuisineTypes.includes(cuisine)
            ? cuisineTypes.filter((c) => c !== cuisine) // remove if exists
            : Array.from(new Set([...cuisineTypes, cuisine])); // add if new

        setValue('cuisineTypes', updated);
    };

    return {
        // form state
        step,
        register,
        handleSubmit,
        errors,
        getValues,
        watch,
        loading,

        // password visibility
        showPassword,
        setShowPassword,

        toggleCuisine,

        // navigation
        handleNextStep,
        handlePreviousStep,

        // submit handler
        onSubmit,
    };
};
